/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * `active` / `inactive`. Coerced from the underlying free-form column; unknown raw values surface as `null`.
 */
export type LeagueStatus = (typeof LeagueStatus)[keyof typeof LeagueStatus];

export const LeagueStatus = {
  active: "active",
  inactive: "inactive",
} as const;
